// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__DRmgP","theme_selector_container":"style_theme_selector_container__33duJ","main":"style_main__3prcR","back_button":"style_back_button__2pGDp"};